import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { customerService, UpdateCustomerData } from '../services/customerService';

export function useCustomerList(params?: { phone_number?: string; tag?: string }) {
  return useQuery({
    queryKey: ['customers', params],
    queryFn: () => customerService.listCustomers(params),
  });
}

export function useCustomerDetail(customerId: string | null) {
  return useQuery({
    queryKey: ['customer-detail', customerId],
    queryFn: () => customerService.getCustomer(customerId!),
    enabled: !!customerId,
  });
}

export function useUpdateCustomer() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateCustomerData }) =>
      customerService.updateCustomer(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['customers'] });
      queryClient.invalidateQueries({ queryKey: ['customer-detail', variables.id] });
      toast.success('Customer updated');
    },
    onError: () => {
      toast.error('Failed to update customer');
    },
  });
}
